import useGroupContext from "pages/[tenant]/g/hooks/useGroupContext";

import { ArrowDownIcon } from "shared/providers/Layout/components/NewTopBar/assets/ArrowDownIcon";
import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";
import useWindowSize from "shared/utils/hooks/useWindowSize";

import { TopbarSidebarMenuContainer } from "./styles";

interface ITopbarSidebarMenuProps {
  shouldChangeButtonTextOnOpen: boolean;
}

export const TopbarSidebarMenu = ({
  shouldChangeButtonTextOnOpen = true,
}: ITopbarSidebarMenuProps) => {
  const {
    openSideMenu,
    closeSideMenu,
    sideMenuIsOpen,
    closeSecondaryMenuContainer,
  } = useTopbarContext();

  const { fetchMyGroups, fetchMyTrail } = useGroupContext();

  const { width } = useWindowSize();
  const isMobile = width <= 850;

  const handleIconClick = async () => {
    if (sideMenuIsOpen) {
      closeSideMenu();
      closeSecondaryMenuContainer();
    } else {
      openSideMenu();
      await fetchMyGroups();
      await fetchMyTrail();
    }
  };

  if (isMobile) return null;
  return (
    <TopbarSidebarMenuContainer
      onClick={handleIconClick}
      sideMenuIsOpen={sideMenuIsOpen}
    >
      {sideMenuIsOpen && shouldChangeButtonTextOnOpen ? (
        "Fechar"
      ) : (
        <>
          Mais <ArrowDownIcon />
        </>
      )}
    </TopbarSidebarMenuContainer>
  );
};
